import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const items = [
    { label: "How It Works", href: "/#services" },
    { label: "Starter Kit", href: "/starter-kit" },
    { label: "Results", href: "/#results" },
    { label: "Pricing", href: "/#pricing" },
    { label: "About", href: "/#about" },
    { label: "Blog", href: "/blog" },
  ];

  return (
    <>
      <div
        className="w-full flex justify-center pt-4 absolute top-0 left-0 right-0 z-40"
        style={{ pointerEvents: "none" }}
      >
        <div className="avail-pill" style={{ pointerEvents: "auto" }}>
          <span className="dot-green dot-blink" />
          <span>2 spots open this month</span>
        </div>
      </div>

      <header
        className={`fixed left-1/2 -translate-x-1/2 z-30 transition-all duration-500 ${
          scrolled ? "top-4" : "top-12"
        }`}
        style={{ width: "min(1280px, calc(100% - 32px))" }}
      >
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="/main-logo.png"
              alt="The LinkedIn Lab"
              className="rounded-xl object-contain"
              style={{ height: 44, width: "auto", display: "block" }}
            />
          </Link>

          <nav
            className="hidden md:flex items-center gap-1 px-3 py-2 rounded-full"
            style={{
              background: "rgba(255,255,255,0.7)",
              backdropFilter: "blur(10px)",
            }}
          >
            {items.map((it) => (
              <a
                key={it.label}
                href={it.href}
                className="px-4 py-2 rounded-full text-[14px] font-medium text-neutral-800 hover:bg-white transition-colors"
              >
                {it.label}
              </a>
            ))}
          </nav>

          <a href="/#booking" className="btn-pill" style={{ padding: "12px 22px" }}>
            Book a Call
          </a>
        </div>
      </header>
    </>
  );
}
